import dayjs from 'dayjs';
import { t } from 'ttag';
import { footerLogoIcon } from './assets';
import './footer.scss';

/**
 * Application footer carrying the Biotricity copyright line and the clinic logo. Composes the current year from dayjs with the build-time app version and build number constants.
 *
 * @returns The footer markup.
 */
const Footer = () => (
  <footer className="app-footer">
    <div className="footer-container">
      <span>
        {`© ${dayjs().year()} ${t`Biotricity All rights reserved.`}${` v${__APP_VERSION_DISPLAY__}.${__APP_BUILD_NUMBER__}`}`}
      </span>
      <div className="logo-for-clinic">
        <img src={footerLogoIcon} alt="logo" />
      </div>
    </div>
  </footer>
);

export default Footer;
